import styled from 'styled-components';
import {Modal,Radio,Space,Divider,Typography,Form,Switch} from 'antd'
const { Title,Text } = Typography;

const CFlex = styled.div`
  display: flex;
  width:100%;
  
 .ant-form-item-control-input-content {
    display: flex;
    justify-content: flex-end;
  }
  .ant-form-item {
    border-top: 1px solid #eaeded;
  }
  .ant-form-item-label {
    padding-left: 32px;
  }
  .ant-modal-body {
    max-height: 75vh;
  }
`

export default ({
  
  columns,
  visibleColumns,
  isModalOpen=false,  
  handleModal=()=>null,
  setVisibleColumns,
  numberItems=10,
  setNumberItems=()=>null
  })=>{  

  return(

    <Modal 
    title="Preferences" 
    okText="Confirm" 
    open={isModalOpen} 
    onOk={handleModal} 
    onCancel={handleModal}   
    >
      <CFlex>
        <div style={{flex:"1 1 auto",flexDirection:"column","display":"flex"}} >
          <Text style={{fontWeight: 500}}>Select page size</Text>
          <Radio.Group onChange={setNumberItems} value={numberItems}>
           <Space direction="vertical">
             <Radio value={10}>{`10 ${"Items"}`}</Radio>
             <Radio value={50}>{`50 ${"Items"}`}</Radio>
             <Radio value={100}>{`100 ${"Items"}`}</Radio>
          </Space>
          </Radio.Group>
        </div>
        <div>
          <Divider type="vertical" style= {{height: "auto"}}/>
        </div>
        <div style={{flex:"1 1 auto",flexDirection:"column"}}>
        <Text style={{fontWeight: 500}}>
           Select visible content
        </Text>
        <Form 
          layout="horizontal"
          initialValues={visibleColumns}
          onValuesChange={(_,o)=>setVisibleColumns&&setVisibleColumns(Object.keys(o).map(key=>o[key]&&key).filter(o=>o!=undefined))}
          // disabled={componentDisabled}
          >
          <Title level={5} style={{fontWeight: 400,paddingTop:10,fontSize:14,color:"#545b64"}}>General Information</Title>
            {columns.map(column=>
              <Form.Item key={column.key} label={column.title||`{ ${column.key} }`} name={column.key} valuePropName="checked" colon={false}>
                <Switch size="small" />
              </Form.Item>
            )}
           
          </Form>
        </div>
      </CFlex>
    </Modal>
  )
}